import adminServiceApi from "src/utils/AdminServiceApi";

const userServices = {
	getUsers: async () => {
		return adminServiceApi().get("user/v1/");
	},
	getStaleUsers: async () => {
		return adminServiceApi().get("user/v1/dashboard/user/stale");
	},
	deleteStaleUsers: async (payload: { userIds: string[] }) => {
		return adminServiceApi().delete(`user/v1/dashboard/user/stale`, {
			data: payload,
		});
	},
	getUsersVerification: async (page: number, limit: number, search: string, filter: string) => {
		return adminServiceApi().get(`user/v1/verification?page=${page}&limit=${limit}&search=${search}&filter=${filter}`);
	},
	getUserVerification: async (user_id: string) => {
		return adminServiceApi().get(`user/v1/verification/${user_id}`);
	},
	getUser: async (user_id: string) => {
		return adminServiceApi().get(`user/v1/profile/${user_id}`);
	},
	updateUser: async (user_id: string, data: any) => {
		return adminServiceApi().put(`user/v1/profile/${user_id}`, data);
	},
	validateAccount: async (payload: {
		account_number: string;
		bank_code: string;
	}) => {
		return adminServiceApi().post(
			"user/v1/admin/wallet/verify-account",
			payload
		);
	},
	updateWithdrawalBank: async (payload: {
		account_number: string;
		bank_code: string;
		bank_name: string;
		user_id: string;
	}) => {
		return adminServiceApi().post("user/v1/admin/wallet/bank", payload);
	},
	DumpCustomerData: async () => {
		return adminServiceApi().get("user/v1/dashboard/dump-data");
	},
	suspendUser: async (user_id: string, data: any) => {
		return adminServiceApi().post(`user/v1/${user_id}/suspend`, data);
	},
	unSuspendUser: async (user_id: string, data: any) => {
		return adminServiceApi().post(`user/v1/${user_id}/unsuspend`, data);
	},
	chargeVerificationFee: async (user_id: string) => {
		return adminServiceApi().post(`user/v1/verification/${user_id}/charge-fee`);
	},
	deleteProfilePic: async (user_id: string) => {
		return adminServiceApi().put(
			`user/v1/profile/remove_profile_picture/${user_id}`
		);
	},
	getUserFeedbacks: async (
		page: number = 1,
		emojiRating: string = "",
		limit: number = 10
	) => {
		return adminServiceApi().get(
			`user/v1/dashboard/user/feedback?page=${page}&emojiRating=${emojiRating}&limit=${limit}`
		);
	},
	getUserPinnedFeedbacks: async (
		page: number = 1,
		emojiRating: string = "",
		limit: number = 10
	) => {
		return adminServiceApi().get(
			`user/v1/dashboard/user/pinned-feedback?page=${page}&emojiRating=${emojiRating}&limit=${limit}`
		);
	},
	pinUserFeedback: async (id: string, pinned: boolean) => {
		return adminServiceApi().put(`user/v1/dashboard/user/pin-feedback/${id}`, {
			pinned,
		});
	},
	exportUserFeedback: async () => {
		return adminServiceApi().get("user/v1/dashboard/user");
	},
};

export default userServices;
